import moment from 'moment-business-days'
import 'moment/locale/nl'
import Bekers from './assets/categories/Bekers.jpg'
import Cacao from './assets/categories/Cacao.jpg'
// import Frisdrank from './assets/categories/Frisdrank.jpg'
import Koek from './assets/categories/Koek.jpg'
import KoffieBonen from './assets/categories/Koffie-Bonen.jpg'
import KoffieFreshbrew from './assets/categories/Koffie-Freshbrew.jpg'
import KoffieVriesdroog from './assets/categories/Koffie-Vriesdroog.jpg'
import KoffieLiquid from './assets/categories/Koffie-Liquid.jpg'
import Machinereiniging from './assets/categories/Machinereiniging.jpg'
import Melk from './assets/categories/Melk.jpg'
import Schoonmaak from './assets/categories/Schoonmaak.jpg'
// import Servies from './assets/categories/Servies.jpg'
import Soep from './assets/categories/Soep.jpg'
import Suiker from './assets/categories/Suiker.jpg'
import TheeFairTrade from './assets/categories/Thee-fairtrade-2.jpg'
import TheeNormaal from './assets/categories/Thee-normaal.jpg'
import Overig from './assets/categories/Non-food-overig.jpg'
moment.locale('nl')

let helpers = {
  splitDate: function(date) {
    const dateArray = date.split(' ')
    return {
      date: dateArray[0],
      time: dateArray[1]
    }
  },

  calculateDateDifference: function(date) {
    date = moment(date, 'MM-DD-YYYY')
    const currentDate = moment()
    return date.diff(currentDate, 'days')
  },

  formattedDate: function(date) {
    return moment(date, 'MM-DD-YYYY')
      .format('DD MMM YY')
      .toString()
  },

  relativeDate: function(date) {
    const givenDate = moment(date, 'MM-DD-YYYY')
    const currentDate = moment()

    if (givenDate.diff(currentDate, 'days') <= 1) {
      return 'Morgen'
    } else {
      return givenDate.format('DD MMM YY').toString()
    }
  },

  today: function() {
    return moment()
      .format('dddd D MMMM YYYY')
      .toString()
  },

  currentWeek: function() {
    return moment()
      .week()
      .toString()
  },

  strippedProducts: function(categories) {
    // return {
    //   coffee: categories.find(category => category.category === 'KFB').products.concat(
    //     categories
    //       .find(category => category.category === 'KFBF')
    //       .products.concat(categories.find(category => category.category === 'KFG').products)
    //       .concat(categories.find(category => category.category === 'KFGF').products)
    //       .concat(categories.find(category => category.category === 'KFL').products)
    //       .concat(categories.find(category => category.category === 'KFLF').products)
    //       .concat(categories.find(category => category.category === 'KFV').products)
    //       .concat(categories.find(category => category.category === 'KFVF').products)
    //   ),
    //   thee: categories
    //     .find(category => category.category === 'THE')
    //     .products.concat(categories.find(category => category.category === 'THEF').products),
    //   food: categories
    //     .find(category => category.category === 'SOE')
    //     .products.concat(categories.find(category => category.category === 'KOE').products)
    //     .concat(categories.find(category => category.category === 'CAC').products)
    //     .concat(categories.find(category => category.category === 'TOP').products)
    //     .concat(categories.find(category => category.category === 'SUI').products)
    //     .concat(categories.find(category => category.category === 'MLK').products)
    //     .concat(categories.find(category => category.category === 'FRI').products),
    //   nonfood: categories
    //     .find(category => category.category === 'BEK')
    //     .products.concat(categories.find(category => category.category === 'BEP').products)
    //     .concat(categories.find(category => category.category === 'ROE').products)
    //     .concat(categories.find(category => category.category === 'HYG').products)
    //     .concat(categories.find(category => category.category === 'SMK').products)
    //     .concat(categories.find(category => category.category === 'REI').products)
    //     .concat(categories.find(category => category.category === 'SER').products)
    // }

    return categories
      .find(category => category.category === 'KFB')
      .products.concat(
        categories
          .find(category => category.category === 'KFBF')
          .products.concat(categories.find(category => category.category === 'KFG').products)
          .concat(categories.find(category => category.category === 'KFGF').products)
          .concat(categories.find(category => category.category === 'KFGRF').products)
          .concat(categories.find(category => category.category === 'KFVRF').products)
          .concat(categories.find(category => category.category === 'KFL').products)
          .concat(categories.find(category => category.category === 'KFBRA').products)
          .concat(categories.find(category => category.category === 'KFLF').products)
          .concat(categories.find(category => category.category === 'KFV').products)
          .concat(categories.find(category => category.category === 'KFVF').products)
          .concat(categories.find(category => category.category === 'THE').products)
          .concat(categories.find(category => category.category === 'THEF').products)
          .concat(categories.find(category => category.category === 'THERF').products)
          .concat(categories.find(category => category.category === 'SOE').products)
          .concat(categories.find(category => category.category === 'KOE').products)
          .concat(categories.find(category => category.category === 'CAC').products)
          .concat(categories.find(category => category.category === 'TOP').products)
          .concat(categories.find(category => category.category === 'SUI').products)
          .concat(categories.find(category => category.category === 'MLK').products)
          .concat(categories.find(category => category.category === 'FRI').products)
          .concat(categories.find(category => category.category === 'BEK').products)
          .concat(categories.find(category => category.category === 'BEP').products)
          .concat(categories.find(category => category.category === 'ROE').products)
          .concat(categories.find(category => category.category === 'HYG').products)
          .concat(categories.find(category => category.category === 'SMK').products)
          .concat(categories.find(category => category.category === 'REI').products)
          .concat(categories.find(category => category.category === 'SER').products)
          .concat(categories.find(category => category.category === 'ONF').products)
          .concat(categories.find(category => category.category === 'OFO').products)
      )
  },

  filterProducts: function(categories) {
    let object = {}
    object['Koffie'] = {}
    object['Thee'] = {}
    object['Food'] = {}
    object['Non-food'] = {}

    // Merge all coffee products
    object['Koffie']['Bonenkoffie'] = {
      description: 'Pure koffie met een volle smaak.',
      image: KoffieBonen,
      products: categories
        .find(category => category.category === 'KFB')
        .products.concat(categories.find(category => category.category === 'KFBF').products.concat(categories.find(category => category.category === 'KFBRA').products))
    }
    object['Koffie']['Freshbrew koffie'] = {
      description: 'Een volle koffie met een milde smaak in zeven verschillende melanges.',
      image: KoffieFreshbrew,
      products: categories
        .find(category => category.category === 'KFG')
        .products.concat(categories.find(category => category.category === 'KFGF').products).concat(categories.find(category => category.category === 'KFGRF').products)
    }
    object['Koffie']['Liquid koffie'] = {
      description: 'Vloeibaar goud, een echte allemansvriend: vol van smaak en niet te sterk.',
      image: KoffieLiquid,
      products: categories
        .find(category => category.category === 'KFL')
        .products.concat(categories.find(category => category.category === 'KFLF').products)
    }
    object['Koffie']['Vriesdroog koffie'] = {
      description: 'Een instantkoffie met behoud van smaak en aroma.',
      image: KoffieVriesdroog,
      products: categories
        .find(category => category.category === 'KFV')
        .products.concat(categories.find(category => category.category === 'KFVF').products).concat(categories.find(category => category.category === 'KFVRF').products)
    }

    // Merge all thee products
    object['Thee']['Normaal'] = {
      description: 'Rijke thee in een rijk aantal verschillende soorten en smaken.',
      image: TheeNormaal,
      products: categories.find(category => category.category === 'THE').products.concat(categories.find(category => category.category === 'THERF').products)
    }
    object['Thee']['Fairtrade'] = {
      description: 'Topkwaliteit thee met zorg voor natuur en medewerker.',
      image: TheeFairTrade,
      products: categories.find(category => category.category === 'THEF').products
    }

    // Merge all food products
    object['Food']['Soep'] = {
      description: 'Een heerlijke soep in een handomdraai, in elke smaak verkrijgbaar.',
      image: Soep,
      products: categories.find(category => category.category === 'SOE').products
    }
    object['Food']['Koek'] = {
      description: 'Bij de koffie hoort een koekje, voor ieder wat wils.',
      image: Koek,
      products: categories.find(category => category.category === 'KOE').products
    }
    object['Food']['Suiker'] = {
      description: 'Suiker in diverse soorten. Klontjes, pakken, sticks en zoetstof.',
      image: Suiker,
      products: categories.find(category => category.category === 'SUI').products
    }
    object['Food']['Melk'] = {
      description: 'Verschillende soorten melk. Zowel cupjes als poeder, sticks en pakken.',
      image: Melk,
      products: categories.find(category => category.category === 'MLK').products
    }
    object['Food']['Cacao & Topping'] = {
      description: 'De finishing touch. Verkrijgbaar in zakken en sticks.',
      image: Cacao,
      products: categories
        .find(category => category.category === 'CAC')
        .products.concat(categories.find(category => category.category === 'TOP').products)
    }
    object['Food']['Cacao & Topping'] = {
      description: 'De finishing touch. Verkrijgbaar in zakken en sticks.',
      image: Cacao,
      products: categories
        .find(category => category.category === 'CAC')
        .products.concat(categories.find(category => category.category === 'TOP').products)
    }

    // Merge all nonFood products
    object['Non-food']['Bekers'] = {
      description: 'Alles om het compleet te maken. Soepbekers, drinkbekers, lepels en roerstaafjes.',
      image: Bekers,
      products: categories
        .find(category => category.category === 'BEK')
        .products.concat(categories.find(category => category.category === 'BEP').products)
        .concat(categories.find(category => category.category === 'ROE').products)
    }
    object['Non-food']['Machinereiniging'] = {
      description: 'Alles voor de beste en meest optimale reiniging van uw machine.',
      image: Machinereiniging,
      products: categories.find(category => category.category === 'REI').products
    }
    object['Non-food']['Schoonmaak'] = {
      description: 'Alles wat u nodig heeft voor een nette en schone omgeving.',
      image: Schoonmaak,
      products: categories
        .find(category => category.category === 'SMK')
        .products.concat(categories.find(category => category.category === 'HYG').products)
    }
    object['Non-food']['Overig'] = {
      description: 'Alles voor de presentatie van uw koffie, thee en soep.',
      image: Overig,
      products: categories.find(category => category.category === 'ONF').products
    }

    return object
  },

  calculatePasswordStrenght: function(password) {
    let object = {
      minimal: false,
      strength: 0
    }

    // minimal length
    if (password.length > 9) {
      object.strength++
      object.minimal = true
    }
    if (password.length > 20) {
      object.strength = 4
      object.minimal = true
      return object
    }
    // The password must contain at least one lowercase letter.
    if (/[A-Z]/.test(password)) {
      object.strength++
    }
    // The password must contain at least one number.
    if (/[0-9]/.test(password)) {
      object.strength++
    }
    // The password must contain at least one special character.
    if (/[^A-Za-z0-9]/.test(password)) {
      object.strength++
    }

    return object
  },

  getStatusText: function(portalOrder, servicePackage, nextDeliveryDate, suspended, delivery, ociPlatform) {
    const deliveryCode = delivery ? delivery.code : '0'
    if (suspended) {
      return 'U heeft een leverstop. Heeft u hier vragen over? Neem dan <a href="/contact">contact</a> met ons op.'
    } else if (servicePackage === 'Flexibel') {
      if ((!portalOrder || (!portalOrder.submitted && !portalOrder.code)) && deliveryCode !== '40') {
        return 'Bent u gebrand op nieuwe koffie? Onze bezorgers staan weer in de startblokken, uw melding is het startschot. Wijzig de aantallen en klik op bestellen. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.'
      } else if ((!portalOrder || (!portalOrder.submitted && !portalOrder.code)) && deliveryCode === '40') {
        return `Uw huidige bestelling komen we leveren op ${moment(delivery.deliveryDate).format(
          'dddd D MMMM'
        )}. U gaat momenteel een nieuwe bestelling plaatsen.<br><br> Onze bezorgers staan weer in de startblokken, uw melding is het startschot. Wijzig de aantallen en klik op bestellen. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder.submitted && ociPlatform) {
        return `<h3>Bestelling verzonden</h3>Uw bestelling is verzonden naar ${ociPlatform}. Zodra deze is goedgekeurd gaan wij voor u aan de slag. We proberen uw producten zo snel mogelijk te leveren. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder.submitted && !portalOrder.code) {
        return '<h3>Bestelling verzonden</h3>Uw bestelling is verzonden en wordt verwerkt. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op. <br/><br/>Wilt u een wijziging versturen? Wijzig de aantallen en verstuur de bestelling opnieuw. Het kan tot 10 minuten duren voordat uw bestelling overal in het portaal is verwerkt.'
      } else if (portalOrder.code === '30' || portalOrder.code === '35') {
        return `<h3>Bestelling verzonden</h3>Bekijk hier het overzicht van uw bestelling.  Wij komen in week ${
          moment(portalOrder.deliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(portalOrder.deliveryDate).format('ww') +
              '/' +
              moment(portalOrder.deliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(portalOrder.deliveryDate).format('ww')
        } uw bestelling leveren. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op. <br/><br/>Wilt u een wijziging versturen? Wijzig de aantallen en verstuur de bestelling opnieuw. Het kan vervolgens maximaal 10 minuten duren voordat uw wijziging overal zichtbaar is.`
      } else if (portalOrder.code === '40') {
        return `Bekijk hier het overzicht van uw bestelling. Wij komen op ${moment(portalOrder.deliveryDate).format(
          'dddd D MMMM'
        )} uw bestelling leveren. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder.code === '25') {
        return `Bekijk hier het overzicht van uw bestelling. Uw bestelling wordt per post verzonden. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      }
    } else if (servicePackage === 'Ondersteun') {
      if (!portalOrder) {
        return `Er staat nog geen bestelling voor u klaar. Hieronder vindt u de standaard aantallen die we bij de volgende bestelling vooraf invullen. Rond week ${
          moment(nextDeliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(nextDeliveryDate).format('ww') +
              '/' +
              moment(nextDeliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(nextDeliveryDate).format('ww')
        } staat er weer een nieuwe bestelling voor u klaar. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder && !portalOrder.submitted && portalOrder.code === '27') {
        return `Uw bestelling staat voor u klaar. Onze bezorgers staan weer in de startblokken, uw melding is het startschot. Pas eventueel de aantallen aan en klik op bevestigen en daarna bestellen. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.<br/><br/>Heeft u op dit moment geen producten nodig? Neem dan <a href="/contact">contact</a> met ons op om de bestelling te annuleren. Er staat weer een nieuwe bestelling voor u klaar rond week ${
          moment(nextDeliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(nextDeliveryDate).format('ww') +
              '/' +
              moment(nextDeliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(nextDeliveryDate).format('ww')
        }.`
      } else if (portalOrder && portalOrder.submitted && portalOrder.code === '27') {
        return `<h3>Bestelling verzonden</h3>Uw bestelling is verzonden en wordt verwerkt. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op. <br/><br/>Wilt u een wijziging versturen? Wijzig de aantallen en verstuur de bestelling opnieuw. Het kan vervolgens maximaal 10 minuten duren voordat uw wijziging overal zichtbaar is.`
      } else if ((portalOrder && portalOrder.code === '30') || (portalOrder && portalOrder.code === '35')) {
        return `<h3>Bestelling verzonden</h3>Bekijk hier het overzicht van uw bestelling. Wij komen in week ${
          moment(portalOrder.deliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(portalOrder.deliveryDate).format('ww') +
              '/' +
              moment(portalOrder.deliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(portalOrder.deliveryDate).format('ww')
        } uw bestelling leveren. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op. <br/><br/>Wilt u een wijziging versturen? Wijzig de aantallen en verstuur de bestelling opnieuw. Het kan vervolgens maximaal 10 minuten duren voordat uw wijziging overal zichtbaar is.`
      } else if (portalOrder && portalOrder.code === '40') {
        return `Bekijk hier het overzicht van uw bestelling. Wij komen op ${moment(portalOrder.deliveryDate).format(
          'dddd D MMMM'
        )} uw bestelling leveren. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder.code === '25') {
        return `Bekijk hier het overzicht van uw bestelling. Uw bestelling wordt per post verzonden. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      }
    } else if (servicePackage === 'Ontzorg') {
      if (!portalOrder) {
        return `Bekijk hier het overzicht van uw bestelling. Wij komen in week ${
          moment(nextDeliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(nextDeliveryDate).format('ww') +
              '/' +
              moment(nextDeliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(nextDeliveryDate).format('ww')
        } uw assortiment weer aanvullen tot onderstaande hoeveelheden. Wilt u een wijziging doorgeven? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if ((portalOrder && portalOrder.code === '30') || (portalOrder && portalOrder.code === '35')) {
        return `Bekijk hier het overzicht van uw bestelling. Wij komen in week ${
          moment(portalOrder.deliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(portalOrder.deliveryDate).format('ww') +
              '/' +
              moment(portalOrder.deliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(portalOrder.deliveryDate).format('ww')
        } uw assortiment weer aanvullen tot onderstaande hoeveelheden. Komt dat moment u niet uit? Of heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder && portalOrder.code === '40') {
        return `Bekijk hier het overzicht van uw bestelling. Wij komen op ${moment(portalOrder.deliveryDate).format(
          'dddd D MMMM'
        )} uw assortiment weer aanvullen tot onderstaande hoeveelheden. Komt dat moment u niet uit? Of heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      } else if (portalOrder.code === '25') {
        return `Bekijk hier het overzicht van uw bestelling. Uw bestelling wordt per post verzonden. Heeft u behoefte aan extra producten in uw assortiment? Neem dan <a href="/contact">contact</a> met ons op.`
      }
    }
  },

  getNotifications: function(portalOrder, errors, messages, servicePackage, nextDeliveryDate, suspended) {
    let notices = []
    let appointments = []
    if (suspended) {
      notices.push({
        content: 'Op dit moment heeft u een leverstop.',
        subtitle: 'Bij vragen kunt u contact opnemen.',
        page: '/contact'
      })
    } else if (portalOrder) {
      if (!portalOrder.submitted && !portalOrder.code) {
        notices.push({
          content: 'Uw bestellijst staat klaar.',
          page: '/bestellijst'
        })
      } else if (!portalOrder.submitted && servicePackage === 'Ondersteun' && portalOrder.code === '27') {
        notices.push({
          content: 'Uw bestellijst staat klaar.',
          page: '/bestellijst'
        })
      } else if (servicePackage === 'Flexibel' && !portalOrder.deliveryNumber) {
        notices.push({
          content: `Uw bestelling wordt ingepland.`,
          subtitle: 'U kunt nog wijzigingen verzenden.',
          page: '/bestellijst'
        })
      } else if (portalOrder.submitted && portalOrder.code === '27' && servicePackage === 'Ondersteun') {
        notices.push({
          content: `Bestelling #${portalOrder.deliveryNumber} wordt ingepland.`,
          subtitle: 'U kunt nog wijzigingen verzenden.',
          page: '/bestellijst'
        })
      } else if (servicePackage !== 'Ontzorg' && (portalOrder.code === '30' || portalOrder.code === '35')) {
        notices.push({
          content: `Bestelling #${portalOrder.deliveryNumber} wordt ingepland.`,
          subtitle: 'U kunt nog wijzigingen verzenden.',
          page: '/bestellijst'
        })
        appointments.push({
          content: 'Levering producten',
          subtitle: `Bestelling #${portalOrder.deliveryNumber} wordt verwerkt. We komen in week ${
            moment(portalOrder.deliveryDate)
              .nextBusinessDay()
              .format('dddd') === 'maandag'
              ? moment(portalOrder.deliveryDate).format('ww') +
                '/' +
                moment(portalOrder.deliveryDate)
                  .nextBusinessDay()
                  .format('ww')
              : moment(portalOrder.deliveryDate).format('ww')
          } leveren.`,
          date: portalOrder.deliveryDate,
          week: true
        })
      } else if (servicePackage === 'Ontzorg' && (portalOrder.code === '30' || portalOrder.code === '35')) {
        notices.push({
          content: `Bestelling #${portalOrder.deliveryNumber} wordt ingepland.`,
          page: '/bestellijst'
        })
        appointments.push({
          content: 'Levering producten',
          subtitle: `Bestelling #${portalOrder.deliveryNumber} wordt verwerkt. We komen in week ${
            moment(portalOrder.deliveryDate)
              .nextBusinessDay()
              .format('dddd') === 'maandag'
              ? moment(portalOrder.deliveryDate).format('ww') +
                '/' +
                moment(portalOrder.deliveryDate)
                  .nextBusinessDay()
                  .format('ww')
              : moment(portalOrder.deliveryDate).format('ww')
          } leveren.`,
          date: portalOrder.deliveryDate,
          week: true
        })
      } else if (portalOrder.code === '40') {
        notices.push({
          content: `We komen ${moment(portalOrder.deliveryDate).format('dddd D MMMM')} leveren.`,
          subtitle: 'Uw bestelling is definitief ingepland.',
          page: '/bestellijst'
        })
        appointments.push({
          content: 'Levering producten',
          subtitle: `Leverdatum voor bestelling #${portalOrder.deliveryNumber} is bekend`,
          date: portalOrder.deliveryDate,
          week: false
        })
      } else if (portalOrder.code === '25') {
        notices.push({
          content: `Uw bestelling wordt per post verzonden.`,
          page: '/bestellijst'
        })
      }
    } else if (servicePackage === 'Flexibel') {
      notices.push({
        content: 'Uw bestellijst staat klaar.',
        page: '/bestellijst'
      })
    }
    if (servicePackage === 'Ontzorg') {
      appointments.push({
        content: 'Eerstvolgende levermoment',
        subtitle: `We komen in week ${
          moment(nextDeliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(nextDeliveryDate).format('ww') +
              '/' +
              moment(nextDeliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(nextDeliveryDate).format('ww')
        } uw assortiment weer bij u aanvullen.`,
        date: nextDeliveryDate,
        week: true
      })
    } else if (servicePackage === 'Ondersteun') {
      appointments.push({
        content: 'Eerstvolgende bestelmoment',
        subtitle: `Er staat rond week ${
          moment(nextDeliveryDate)
            .nextBusinessDay()
            .format('dddd') === 'maandag'
            ? moment(nextDeliveryDate).format('ww') +
              '/' +
              moment(nextDeliveryDate)
                .nextBusinessDay()
                .format('ww')
            : moment(nextDeliveryDate).format('ww')
        } een nieuwe bestelling voor u klaar.`,
        date: nextDeliveryDate,
        week: true
      })
    }
    if (errors) {
      errors.map(error => {
        if (moment().diff(error.createdAt) < 86400000) {
          notices.push({
            content: `Uw storingsmelding van ${moment(error.createdAt).format('D MMM')} is verzonden.`,
            page: ''
          })
        }
        return ''
      })
    }
    if (messages) {
      messages.map(message => {
        if (moment().diff(message.createdAt) < 86400000) {
          notices.push({
            content: `Uw bericht van ${moment(message.createdAt).format('D MMM')} is verzonden.`,
            page: ''
          })
        }
        return ''
      })
    }

    return { notices, appointments }
  },

  translateUnits: function(unit) {
    const units = [
      { value: 'Doos', singular: 'Doos', plural: 'Dozen'},
      { value: 'Fles', singular: 'Fles', plural: 'Flessen'},
      { value: 'Pak', singular: 'Pak', plural: 'Pakken'},
      { value: 'Rol', singular: 'Rol', plural: 'Rollen'},
      { value: 'Pot', singular: 'Pot', plural: 'Potten'},
      { value: 'Stuk', singular: 'Stuk', plural: 'Stuks'},
      { value: 'Zak', singular: 'Zak', plural: 'Zakken'},
      { value: 'Tray', singular: 'Tray', plural: 'Trays'},
    ]

    const selected = units.filter(el => el.value === unit)
    return selected.length > 0 ? selected[0] : unit
  },

  getInsertions: function() {
    return [
      { value: '', label: '' },
      { value: 'd', label: "d'" },
      { value: 'de', label: 'de' },
      { value: 'dela', label: 'de la' },
      { value: 'den', label: 'den' },
      { value: 'der', label: 'der' },
      { value: 'di', label: 'di' },
      { value: 'dos', label: 'dos' },
      { value: 'du', label: 'du' },
      { value: 'een', label: 'een' },
      { value: 'el', label: 'el' },
      { value: 'het', label: 'het' },
      { value: 'indn', label: 'in den' },
      { value: 'indr', label: 'in der' },
      { value: 'int', label: "in 't" },
      { value: 'la', label: 'la' },
      { value: 'le', label: 'le' },
      { value: 'opde', label: 'op de' },
      { value: 'opden', label: 'op den' },
      { value: 'opder', label: 'op der' },
      { value: 't', label: "'t" },
      { value: 'te', label: 'te' },
      { value: 'ten', label: 'ten' },
      { value: 'ter', label: 'ter' },
      { value: 'van', label: 'van' },
      { value: 'vande', label: 'van de' },
      { value: 'vandn', label: 'van den' },
      { value: 'vandr', label: 'van der' },
      { value: 'vanht', label: 'van het' },
      { value: 'vant', label: "van 't" },
      { value: 'von', label: 'von' },
      { value: 'voodn', label: 'voor den' }
    ]
  },

  findInsertion: function(insertion) {
    const insertions = this.getInsertions()
    const selected = insertions.filter(inser => inser.value === insertion)
    return selected.length > 0 ? selected[0].label : insertion
  }
}

export default helpers



// WEBPACK FOOTER //
// ./src/helpers.js